module.exports = "/assets/js/7ee53966ca74275a7aee4bae7d58d86a.svg";